export default __webpack_public_path__ + "static/96dc6d98-013d-4a94-9c09-8476abc0abc6-fe787d295f87f7d8c7e940958a1fb023.ttf";